import { useController } from "react-hook-form";
import React, { useEffect } from "react";

export function FormHidden({ value, name }: { value: any; name: string }) {
  const {
    field: { ref, onChange, value: internalValue },
  } = useController({ name });

  useEffect(() => {
    onChange(value);
  }, [value]);

  return <input ref={ref} type={"hidden"} value={internalValue} />;
}
